import api from './api';

const accountService = {
  // Get all accounts
  getAccounts: async () => {
    const response = await api.get('/accounts');
    return response.data;
  },

  // Get account by ID
  getAccount: async (id) => {
    const response = await api.get(`/accounts/${id}`);
    return response.data;
  },

  getPrivacy: async (id) => {
    const response = await api.get(`/accounts/${id}/privacy`);
    return response.data.data;
  },

  updatePrivacy: async (id, changes) => {
    const response = await api.patch(`/accounts/${id}/privacy`, changes);
    return response.data.data;
  },

  // Create new account
  createAccount: async (accountData) => {
    const response = await api.post('/accounts', accountData);
    return response.data;
  },

  // Update account
  updateAccount: async (id, accountData) => {
    const response = await api.put(`/accounts/${id}`, accountData);
    return response.data;
  },

  // Change the Messenger role without changing operator or runtime status
  changeAccountRole: async (id, role) => {
    const response = await api.patch(`/accounts/${id}/role`, { role });
    return response.data;
  },

  // Delete account
  deleteAccount: async (id, confirmation) => {
    const response = await api.delete(`/accounts/${id}`, { data: confirmation });
    return response.data;
  },

  // Update account status
  updateAccountStatus: async (id, status) => {
    const response = await api.post(`/accounts/${id}/status`, { status });
    return response.data;
  },

  // Start account creation process
  startAccountCreation: async (accountData) => {
    const response = await api.post('/accounts/create', accountData);
    return response.data;
  },

  // Verify account with code
  verifyAccount: async (name, code) => {
    const response = await api.post('/accounts/verify', { name, code });
    return response.data;
  },

  // Start account authorization process
  authorizeAccount: async (id) => {
    const response = await api.post(`/accounts/${id}/authorize`);
    return response.data;
  },

  // Start account authorization process via QR
  authorizeAccountWithQr: async (id) => {
    const response = await api.post(`/accounts/${id}/authorize-qr`);
    return response.data;
  },

  // Refresh QR authentication token
  refreshAccountQrAuth: async (id) => {
    const response = await api.post(`/accounts/${id}/authorize-qr/refresh`);
    return response.data;
  },

  // Get current authorization status for active auth session
  getAuthorizationStatus: async (id) => {
    const response = await api.get(`/accounts/${id}/authorization-status`);
    return response.data;
  },

  // Verify account with code (for existing account)
  verifyExistingAccount: async (id, code) => {
    const response = await api.post(`/accounts/${id}/verify`, { code });
    return response.data;
  },

  // Verify account with 2FA password
  verifyExistingAccountWithPassword: async (id, password) => {
    const response = await api.post(`/accounts/${id}/verify-password`, { password });
    return response.data;
  },

  // Search for a user by username
  searchUser: async (id, username) => {
    const response = await api.post(`/accounts/${id}/search-user`, { username });
    return response.data;
  },

  // Send a message to a user
  sendMessage: async (id, user_id, message) => {
    const response = await api.post(`/accounts/${id}/send-message`, { user_id, message });
    return response.data;
  },

  // Join chat or topic directly
  joinDirect: async (id, link) => {
    const response = await api.post(`/accounts/${id}/join-direct`, { link });
    return response.data;
  }
};

export default accountService;
